import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { TemplateRendererComponent, suppressTabbingToNextCell } from "@coso/grid";
import { IS_SAAS } from "@coso/utility";
import { ColDef, GridOptions } from "ag-grid-community";
import { ActionType, ILogHolder } from "../../../models/auto-generated";

@Component({
  standalone:false,
  selector: "coso-replicator-logs-table",
  templateUrl: "./logs-table.component.html"
})
export class LogsTableComponent implements OnInit {
  ActionType = ActionType;

  @Input()
  rowData: ILogHolder[];

  @Input()
  caption: string;

  @Input()
  isRealTime: boolean;

  @ViewChild("type", { static: true }) typeRef: TemplateRef<any>;
  @ViewChild("timestamp", { static: true }) timestampRef: TemplateRef<any>;
  gridOptions: GridOptions;
  columnDefs: ColDef[];

  constructor(@Inject(IS_SAAS) public isSaaS: boolean) {}

  ngOnInit(): void {
    this.gridOptions = {
      defaultColDef: { resizable: true, suppressKeyboardEvent: suppressTabbingToNextCell }
    };
    this.columnDefs = [
      {
        headerName: "Type",
        field: "actionType",
        resizable: false,
        maxWidth: 60,
        minWidth: 60,
        cellClassRules: {
          "table-secondary": (params) => params.value === ActionType.DEBUG,
          "table-info": (params) => params.value === ActionType.INFO,
          "table-warning": (params) => params.value === ActionType.WARN,
          "table-danger": (params) => params.value === ActionType.ERROR,
          "table-light": (params) => params.value === ActionType.EVENT,
          "table-success": (params) => params.value === ActionType.PERMISSION_WRITE
        },
        cellRenderer: TemplateRendererComponent,
        cellRendererParams: {
          ngTemplate: this.typeRef
        }
      },
      {
        headerName: "Timestamp (UTC)",
        field: "timeStamp",
        maxWidth: 200,
        cellRenderer: TemplateRendererComponent,
        cellRendererParams: {
          ngTemplate: this.timestampRef
        }
      },
      {
        headerName: "Message",
        field: "message",
        minWidth: 100,
        autoHeight: !this.isRealTime,
        wrapText: !this.isRealTime,
        cellRenderer: (params) => this.escapeHtml(params.value)           
      },
      {
        headerName: "Additional Info",
        field: "additionalText",
        minWidth: 100,
        autoHeight: !this.isRealTime,
        wrapText: !this.isRealTime,
        cellRenderer: (params) => this.escapeHtml(params.value)         
      }
    ];
  }

  private escapeHtml(input: string): string {
    const text = input || "-";
    return text.replace(/[&<>"']/g, match => {
      switch (match) {
        case '&': return '&amp;';
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '"': return '&quot;';
        case "'": return '&#39;';
        default: return match;
      }
    });
  }
}
